"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const qs_1 = require("qs");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const CampaignTypeSelector = ({ closeCampaignTypeSelector, closeMobileCampaignTypeSelector, isCampaignTypeSelectorClosing, isCampaignTypeSelectorOpen, media, openCampaignTypeSelector, history, location, }) => {
    const handleOpenClose = () => {
        if (isCampaignTypeSelectorOpen) {
            closeCampaignTypeSelector();
        }
        else {
            openCampaignTypeSelector();
        }
    };
    const getCampaignTypeIcon = (type) => {
        const iconProps = {
            fill: src_1.steel,
            height: media === 'Desktop' ? '20' : '24',
            width: media === 'Desktop' ? '20' : '24',
            viewBox: '0 0 24 24',
            style: { marginLeft: 10 },
        };
        switch (type) {
            case 'scheduled':
                return React.createElement(src_1.CalendarIcon, Object.assign({}, iconProps));
            case 'automated':
                return React.createElement(src_1.ZapIcon, Object.assign({}, iconProps));
            case 'api':
                return React.createElement(src_1.HashtagIcon, Object.assign({}, iconProps, { viewBox: "0 0 20 20" }));
            case 'web':
                return React.createElement(src_1.LinkIcon, Object.assign({}, iconProps));
            case 'interstitial':
                return React.createElement(src_1.PhoneIcon, Object.assign({}, iconProps));
            case 'all':
            default:
                return React.createElement(src_1.CheckIcon, Object.assign({}, iconProps));
        }
    };
    const getFormattedListType = (type) => {
        switch (type) {
            case 'scheduled':
                return 'Scheduled Notifications';
            case 'automated':
                return 'Automated Notifications';
            case 'api':
                return 'API Notifications';
            case 'web':
                return 'Web/Social Experiences';
            case 'interstitial':
                return 'Interstitial Experiences';
            case 'all':
            default:
                return 'All Campaigns';
        }
    };
    const setListType = (nextType) => {
        const newQuery = qs_1.stringify(Object.assign(Object.assign({}, qs_1.parse(location.search.substring(1))), { campaignType: nextType }));
        history.replace(`/campaigns/?${newQuery}`);
        handleOpenClose();
    };
    const renderCampaignType = (type) => {
        const style = {
            display: 'flex',
            alignItems: 'center',
            height: media === 'Mobile' ? 72 : 56,
            width: '100%',
            borderBottom: `1px solid ${src_1.titanium}`,
            boxSizing: 'border-box',
        };
        const selectedType = qs_1.parse(location.search.substring(1)).campaignType || 'all';
        const textStyle = {
            marginLeft: 26,
            flex: '1 1 auto',
        };
        const radioButtonStyle = {
            outerStyle: { height: 18, width: 18 },
        };
        return (React.createElement("div", { onClick: () => setListType(type), style: style },
            getCampaignTypeIcon(type),
            React.createElement(src_1.Text, { text: getFormattedListType(type), size: "medium", textStyle: textStyle }),
            React.createElement("div", { style: { flex: 'none' } },
                React.createElement(src_1.RadioButton, { selected: type === selectedType, style: radioButtonStyle }))));
    };
    const popoverProps = {
        placement: 'bottom',
        arrowColors: {
            primary: src_1.white,
            secondary: src_1.titanium,
            border: src_1.titanium,
        },
        toggleable: true,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(src_1.PopoverContainer, { id: "campaign-type-selector", popoverProps: popoverProps, onClick: handleOpenClose, targetParent: "root", showPopover: media !== 'Mobile' && isCampaignTypeSelectorOpen },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                } },
                qs_1.parse(location.search.substring(1)).campaignType !== 'all' &&
                    getCampaignTypeIcon(qs_1.parse(location.search.substring(1)).campaignType),
                React.createElement(src_1.Text, { text: getFormattedListType(qs_1.parse(location.search.substring(1)).campaignType), size: "medium", textStyle: { marginLeft: 8 } }),
                React.createElement("div", { style: { height: 16, marginLeft: 4 } },
                    React.createElement(src_1.FilterArrowIcon, null))),
            React.createElement("div", { style: {
                    height: 223,
                    width: 384,
                    flexDirection: 'column',
                    paddingLeft: 16,
                    paddingRight: 16,
                } },
                renderCampaignType('all'),
                renderCampaignType('scheduled'),
                renderCampaignType('automated'),
                renderCampaignType('api'))),
        isCampaignTypeSelectorOpen && media === 'Mobile' && (React.createElement("div", { id: "sendTestId", style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                zIndex: 3,
                position: 'absolute',
                background: src_1.white,
                top: 0,
                left: 0,
                animation: `${isCampaignTypeSelectorClosing ? 'close' : 'open'} 300ms ease`,
                overflowY: 'scroll',
            } },
            React.createElement("div", { style: {
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                } },
                React.createElement(src_1.NavBar, { buttonRight: "Done", buttonLeft: "Cancel", buttonLeftCallback: closeMobileCampaignTypeSelector, buttonRightCallback: closeCampaignTypeSelector, style: {
                        buttonLeftStyle: {
                            innerStyle: {
                                color: src_1.graphite,
                                marginTop: 3,
                            },
                        },
                        buttonRightStyle: {
                            innerStyle: {
                                color: src_1.graphite,
                                marginTop: 3,
                            },
                        },
                    }, title: "" }),
                React.createElement("div", { style: { padding: 24 } },
                    React.createElement(src_1.Text, { size: "h1", text: "Filter Campaigns" }),
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            marginBottom: 24,
                        } },
                        renderCampaignType('all'),
                        renderCampaignType('scheduled'),
                        renderCampaignType('automated'),
                        renderCampaignType('api'))))))));
};
const mapDispatchToProps = (dispatch) => ({
    closeMobileCampaignTypeSelector: () => {
        dispatch({ type: 'START_CLOSING_CAMPAIGN_TYPE_SELECTOR' });
        setTimeout(() => dispatch(actions_1.closeCampaignTypeSelector()), 295);
    },
    closeCampaignTypeSelector: () => dispatch(actions_1.closeCampaignTypeSelector()),
    openCampaignTypeSelector: () => dispatch(actions_1.openCampaignTypeSelector()),
});
const mapStateToProps = (state) => ({
    isCampaignTypeSelectorClosing: reducers_1.getIsCampaignTypeSelectorClosing(state),
    isCampaignTypeSelectorOpen: reducers_1.getIsCampaignTypeSelectorOpen(state),
});
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CampaignTypeSelector));
